import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateClientMutationVariables = Types.Exact<{
  data: Types.UpdateClientInput;
}>;


export type UpdateClientMutation = { updateClient?: { client?: { id: string, clientName: string } | null } | null };


export const UpdateClientDocument = /*#__PURE__*/ gql`
    mutation UpdateClient($data: UpdateClientInput!) {
  updateClient(data: $data) {
    client {
      id
      clientName
    }
  }
}
    `;

export function useUpdateClientMutation() {
  return Urql.useMutation<UpdateClientMutation, UpdateClientMutationVariables>(UpdateClientDocument);
};